import { createMapAction } from "chalet-shared";

export const actionCreators = {
    updateProtoTimeBeforeReconnect: createMapAction(
        "UPDATE_PROTO_TIME_BEFORE_RECONNECT",
        (x: { timeMs: number }) => x
    ),
    clearAppError: createMapAction("CLEAR_APP_ERROR", (x: { errorId: string }) => x),
    clearRoomError: createMapAction(
        "CLEAR_ROOM_ERROR",
        (x: { roomId: string; errorId: string | undefined }) => x
    ),
};
